import axios from '@/helpers/axios';

export function getDashboard() {
  return axios.post('/dealer/dashboard/index', {}).then(({ data }) => {
    return {
      doctors: data.summary.doctors,
      patients: data.summary.patients,
      exams: data.summary.exams,
      calls: data.summary.calls,
    };
  });
}
